import axios from 'axios'

export default {
  namespaced: true,

  state: {
    matches: [],
    types: [],
    match: {},
    count: 0
  },

  getters: {
    all (state) {
      return state.matches
    },

    match (state) {
      return state.match
    },

    types (state) {
      return state.types
    },

    count (state) {
      return state.count
    }
  },

  mutations: {
    SET_MATCHES (state, matches) {
      state.matches = matches
    },

    SET_MATCH (state, match) {
      state.match = match
    },

    UPDATE_MATCH (state, match) {
      let index = state.matches
        .findIndex((row) => { return row.id === match.id })
      if (index !== -1) {
        state.matches[index] = match
      }
    },

    DELETE_MATCH (state, id) {
      let index = state.matches
        .findIndex((row) => { return row.id === id })

      alert()
      if (index !== -1) {
        state.matches.splice(index, 1)
      }
    },

    SET_COUNT (state, count) {
      state.count = count
    },

    SET_TYPES (state, types) {
      state.types = types
    }
  },

  actions: {
    async get ({ commit }, { status, params }) {
      let matches = await axios.get(`/matches/status/${status}`, { params })
      commit('SET_MATCHES', matches.data)
    },

    async find ({ commit }, id) {
      let match = await axios.get(`/matches/${id}`)
      await commit('SET_MATCH', match.data)
    },

    async create ({ commit }, matches) {
      await axios.post('/matches', matches)
    },

    async update ({ commit }, match) {
      await axios
        .patch(`/matches/${match.id}`,
          Object.assign({}, match, { id: undefined })
        )

      commit('UPDATE_MATCH', match)
    },

    async delete ({ commit }, id) {
      await axios.delete(`/matches/${id}`)
      commit('DELETE_MATCH', id)
    },

    async getCount ({ commit }, { status, params }) {
      let count = await axios.get(`/matches/status/${status}/count`, { params })
      commit('SET_COUNT', count.data)
    },

    async getTypes ({ commit }) {
      let types = await axios.get('/matches/types')
      commit('SET_TYPES', types.data)
    }
  }
}
